import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

export enum AlertType {
  SUCCESS = 'custom-success',
  DANGER = 'custom-danger',
  INFO = 'custom-info',
  WARNING = 'custom-warning',
  SHARED = 'custom-shared',
}

export interface AlertItemInterface {
  active?: boolean;
  type?: AlertType.SUCCESS | AlertType.DANGER | AlertType.INFO | AlertType.WARNING | AlertType.SHARED;
  message: string;
  timeout?: number;
  keepOnRouteChange?: boolean;
  modal?: boolean;
}

export class AlertItem {
  config: AlertItemInterface = {
    active: false,
    type: AlertType.INFO,
    message: '',
    timeout: 5000,
    keepOnRouteChange: false,
    modal: false
  };

  constructor(config: AlertItemInterface) {
    Object.assign(this.config, config);
  }
}

@Injectable()
export class AlertBannerService {
  alerts: AlertItem[];
  alertsAdded$ = new Subject();
  alertsScrollTop$ = new Subject();

  constructor() {
    this.alerts = [];
  }

  append(alerts: AlertItemInterface[], clearAlerts = true, scrollTop = true) {
    if (clearAlerts) {
      this.clear();
      alerts = [alerts.pop() as AlertItemInterface];
    }

    alerts.map((item, index) => this.alerts.push(new AlertItem(item)));

    if (scrollTop) this.alertsScrollTop$.next(true);

    this.alertsAdded$.next(true);
  }

  length() {
    return this.alerts.length;
  }

  clear(force = false) {
    if (force) {
      this.alerts = [];
    } else {
      this.alerts = this.alerts.filter((alert: any) => alert.config.keepOnRouteChange === true);
    }
  }

  remove(index: number) {
    this.alerts.splice(index, 1);
  }
}
